import { useState, useEffect } from "react";
import { pusher } from "../../../../utils/pusher";
import { fetchData, getGroupById } from "../../../../utils/ApiCall";

const useBoard = ({
  key,
  apiUrl,
  pathname,
  setGroupItems,
  groups,
  updateRows,
  updateParams,
}) => {
  // Añadido groups como parámetro
  const [boardState, setBoardState] = useState({
    deleteInput: "",
    isDeleteModalOpen: false,
    isModalOpen: false,
    quickFilter: [],
    expandedGroups: new Set([0]),
    modalThreadOpen: false,
  });

  // Efecto para cargar datos iniciales y suscripción a Pusher
  useEffect(() => {
    const loadData = async () => {
      if (!boardState.modalThreadOpen && key && apiUrl) {
        try {
          const data = await fetchData(apiUrl);
          setGroupItems(data);
        } catch (error) {
          console.error("Error loading data:", error);
        }
      }
    };

    const channel = pusher.subscribe(`${pathname.split("/")[1]}-prod`);
    channel.bind("refresh", loadData);

    if (key && apiUrl) {
      loadData();
    }

    return () => {
      channel.unbind("refresh");
      pusher.unsubscribe(`${pathname.split("/")[1]}-prod`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateRows]);

  // Efecto para sincronizar el estado del modal con la variable global
  useEffect(() => {
    window.modalThreadOpen = boardState.modalThreadOpen;
    return () => {
      window.modalThreadOpen = false;
    };
  }, [boardState.modalThreadOpen]);

  // Efecto para manejar actualización de parámetros
  useEffect(() => {
    if (updateParams && groups) {
      // Verificación de groups
      const updateLocation = async () => {
        try {
          const statusRow = await getGroupById(
            updateParams,
            pathname.replace("/", "")
          );
          window.location.href = `#${statusRow}`;
          const groupIndex = groups.findIndex(
            (g) => g.toLowerCase() === statusRow.toLowerCase()
          );

          if (groupIndex !== -1) {
            setBoardState((prev) => ({
              ...prev,
              expandedGroups: new Set([...prev.expandedGroups, groupIndex]),
            }));
          }
        } catch (error) {
          console.error("Error updating location:", error);
        }
      };

      updateLocation();
    }
  }, [pathname, groups, updateParams]); // groups como dependencia

  return {
    boardState,
    setBoardState,
  };
};

export default useBoard;
